<template>
  <div class="categoryAnimal" v-show="show">

    <div class="categoryInfo">
      <div class="topInfo">
        <h5 class="categoryTitle">{{animalType}}</h5>
        <h6 class="categoryTitle2" v-html="animalTypeEn"></h6>
        <div class="categoryTxt" v-html="categoryTxt"></div>
      </div>
      <div class="categoryInfoImg" v-if="categoryInfoImg">
        <img :src="categoryInfoImg">
      </div>
    </div>

    <div class="animalShow">
      <h5 class="categoryTitle">展品展出：</h5>
      <div class="swiper-container" ref="swiperContainer" v-if="cssType !== 'special'">
        <ul class="swiper-wrapper showList">
          <li 
            class="swiper-slide itemShow"
            v-for="item in showList"
            :key="item.id"
             @click="showDetails(item)"
          >
            <div class="itemImg">
              <squareDivImg :addStyle='item.style' :show='show' :imgSrc='item.src'></squareDivImg>
            </div>
            <h6 class="itemTitle">{{item.title}}</h6>
            <p class="itemEnTitle" v-if="nowPage < 4" v-html="item.enTitle"></p>
          </li>
        </ul>
      </div>
      <div class="specialWrap" v-else>
        <div class="specialImg" @click="showDetails(showList[0])">
          <squareDivImg :show='show' :imgSrc='showList[0].src'></squareDivImg>
        </div>
        <div class="specialInfo">
          <h5 class="specialTitle">{{showList[0].title}}</h5>
          <div class="specialEnTitle" v-html="showList[0].enTitle"></div>
          <div class="specialTxt">{{showList[0].details}}</div>
        </div>
      </div>
      <template v-if="showList.length > 3">
        <img :src="prevBtn" @click="swiperToPrev" class="changeBtn prevBtn">
        <img :src="nextBtn" @click="swiperToNext" class="changeBtn nextBtn">
      </template>
    </div>

    <div class="backBtnWrap" @click="changeShowAnimal">
      <img :src="backBtn" class="backBtn"/>
      <span>返回</span>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

import backBtn from '@/assets/img/backBtn.png'
import prevBtn from '@/assets/img/prevBtn.png'
import nextBtn from '@/assets/img/nextBtn.png'



export default {
  name: 'categoryAnimal',
  props: {
    animalType: { // 动物类
      type: String,
      default: ''
    },
    animalTypeEn: { // 动物类-英文
      type: String,
      default: ''
    },
    categoryTxt: { // 动物介绍
      type: String,
      default: ''
    },
    categoryInfoImg: { // 类别图片
      type: String,
      default: ''
    },
    showList: {
      type: Array,
      default () {
        return []
      }
    },
    cssType: { // 默认为空，special为特殊排版
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    nowPage () {
      return this.$store.state.nowPage
    },
  },

  data () {
    return {
      backBtn, // 返回按钮
      prevBtn, // 上一个
      nextBtn, // 下一个
      imgSwiper: null,
      nowNum: 0,
    }
  },

  // watch: {
  //   show ( newShow ) {
  //     console.log('newShow', newShow)
  //     if ( newShow && this.cssType !== 'special' && this.imgSwiper ) {
  //       this.initSwiper()
  //     }
  //     // if ( newShow &&  this.imgSwiper ) {
  //     //   this.imgSwiper.init()
  //     // }
  //   }
  // },

  mounted () {
    if ( this.cssType !== 'special' ) {
      this.initSwiper()
    }
    
  },

  methods: {
    changeShowAnimal () {
      this.$emit('changeShowAnimal', 0)
      this.$store.dispatch('setNextBtn', true)
    },

    initSwiper () { // 初始化swiper
      // let _this = this
      this.imgSwiper = new Swiper(this.$refs.swiperContainer, {
        observer: true, 
        observeParents: true,
        updateOnImagesReady: true,
        slidesPerView: 3,
        spaceBetween: 30,
        // slidesPerGroup: 3,
      })
    },

    swiperToNext () { // 下一个
      this.imgSwiper.slideNext();
    },

    swiperToPrev () { // 上一个
      this.imgSwiper.slidePrev();
    },

    showDetails ( item ) {
      this.$store.dispatch('changeSingleWork', true)
      this.$store.dispatch('setSingleWork', item)
    },

    
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './categoryAnimal.styl'
</style>